export const MORALIS_API_URL = "https://deep-index.moralis.io/api/v2/";
export const MORALIS_API_KEY = "asP7RGFyyIcoQnhXql7bFM3zK1i9o4xgBmt8Ut0yHdPLvj69DQ8zZYVZty24wFkL";

export const DIRECTUS_API_URL = "https://farandole.directus.app/";

export const MARKETPLACE_CONTRACT_ADDRESS = "0xdA9aB162A1567a1a15A1d288059221E9Ce8CF81C";

export const FARANDOLE_WALLET = "0x201d79faFF10dBd2Ae2b47D6b2FF9b7c52CF2EE3";

